import script from "./Authentication.vue?vue&type=script&setup=true&lang=js"
export * from "./Authentication.vue?vue&type=script&setup=true&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=6331498e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6331498e"]])

export default __exports__